<script setup>
defineProps({
  visible: {
    type: Boolean,
    required: true,
  },
});
</script>

<template>
  <Transition name="expand">
    <slot v-if="visible" />
  </Transition>
</template>

<style scoped lang="scss">
.expand-enter-active,
.expand-leave-active {
  transform: translateX(0);
  transition: transform var(--transition-slow);
}

.expand-enter-from,
.expand-leave-to {
  transform: translateX(100%);
}
</style>
